/*
 * Copyright (c) 2025. Bolmate B.V.
 */
import React, {useMemo} from 'react';
import {useTranslation} from 'react-i18next';

import {NotificationProps, NotificationTypeProps} from '../notificationsPage';

import useDefaultNotification from '../useDefaultNotification';

import NotificationProducts from '../notificationComponents/notificationProducts';

import NotificationEmail from '../notificationComponents/notificationEmail';

import NotificationActions from '../notificationComponents/notificationActions';

import Notification from '../../../models/notificationModel';

import {NotificationType} from '../../../util/enums';

import {AwesomeIcon} from '@dvrd/dvr-controls';

import classNames from 'classnames';

import BolmateBadgePremium from '../bolmateBadgePremium';

function ProductHijackNotification(props: NotificationProps) {
    const {t} = useTranslation();
    const {
        notification,
        loading,
        onDeleteNotification,
        onSendTestNotification,
        disabled,
        canDelete,
        canEdit,
        onReplaceNotification
    } = props;
    const [onChangeEmailAddresses] = useDefaultNotification(props);

    return (
        <div className={classNames('product-hijack-notification notification-config', disabled && 'disabled')}>
            <label className='notification-title'>
                <AwesomeIcon name='user-shield' className='type-icon' />{' '}
                {t('notifications.productHijack.title', 'Productkaping notificatie')} <BolmateBadgePremium />
            </label>
            <div className='notification'>
                <NotificationProducts
                    onSuccess={onReplaceNotification}
                    notification={notification}
                    disabled={loading || disabled || !canEdit}
                    text={t('notifications.productHijack.productsText', 'Bij een nieuwe verkoper op')}
                />
                <NotificationEmail
                    onChangeEmailAddresses={onChangeEmailAddresses}
                    emailAddresses={notification.emailAddresses}
                    disabled={loading || disabled || !canEdit}
                />
            </div>
            <NotificationActions
                onDeleteNotification={onDeleteNotification}
                onSendTestNotification={onSendTestNotification}
                disabled={disabled}
                notification={notification}
                canDelete={canDelete}
            />
        </div>
    );
}

export default function ProductHijackNotifications(props: NotificationTypeProps) {
    const {notifications, moduleActive} = props;
    const hijackNotifications = useMemo(() => {
        return notifications.filter(
            (notification: Notification) => notification.notificationType === NotificationType.PRODUCT_HIJACK
        );
    }, [notifications]);
    if (!hijackNotifications.length) return null;

    function renderNotification(notification: Notification, index: number) {
        return (
            <ProductHijackNotification key={index} notification={notification} disabled={!moduleActive} {...props} />
        );
    }

    return (
        <div className='notification-type product-hijack-notifications'>
            <div className='notifications'>{hijackNotifications.map(renderNotification)}</div>
        </div>
    );
}
